import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IProofRoutingModule } from './i-proof-routing.module';
import { IProofComponent } from './i-proof.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatRadioModule } from '@angular/material/radio';



@NgModule({
  declarations: [
    IProofComponent
  ],
  imports: [
    CommonModule,
    IProofRoutingModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    // BrowserAnimationsModule,
    FormsModule
  ]
})
export class IProofModule { }
